import providers from '@/configurations/sso/providers'
import { clone as _clone } from 'lodash'

export default class Provider {
  constructor ({ id = null, name = null, provider = null, visibility = [] } = {}) {
    this.id = id
    this.name = name
    this.provider = provider
    this.visibility = visibility
  }

  get configuration () {
    return _clone(providers.find(({ provider }) => provider === this.provider))
  }

  get component_path () {
    return this.configuration?.component_path
  }

  get category () {
    return this.configuration?.category || 'custom'
  }

  get is_allowed () {
    return this.visibility.includes('platform') && !!this.component_path
  }
}